import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DomUtils, IconButton, TrashIcon } from '@onsolve/onsolve-ui-components';

import withKeyboardControl from '../Utils/KeyboardControl';
import keyCodes from '@components/GlobalSearch/Utils/keyCodes';

const { TAB, UP, DOWN, ENTER_KEY } = keyCodes;

import './RecentSearches.scss';

class RecentSearchesItems extends Component {
    constructor(props) {
        super(props);

        this.elementRef = React.createRef();
    }

    componentDidUpdate(prevProps) {
        const { current } = this.elementRef;
        const { currentIndex, isSelected, focusCurrentTrash } = this.props;

        if (current) {
            DomUtils.setFocus(current);
            (prevProps.currentIndex !== currentIndex || prevProps.isSelected !== isSelected) &&
                current.scrollIntoView();
        }

        focusCurrentTrash && current?.children.length && current.children[0].focus();
    }

    handleKeyDown = item => e => {
        const { keyCode } = e;
        const { onItemClick } = this.props;

        keyCode === ENTER_KEY && onItemClick(item);
    };

    handleItemClick = item => () => {
        const { onItemClick } = this.props;

        onItemClick(item);
    };

    handleTab = e => {
        const { keyCode } = e;
        const { tabOnTrash } = this.props;

        [TAB, UP, DOWN].includes(keyCode) && tabOnTrash(e);
    };

    getReference = item => {
        const { recentSearches, currentIndex, isSelected } = this.props;

        return isSelected && recentSearches[currentIndex] === item ? this.elementRef : undefined;
    };

    render() {
        const { recentSearches, removeItem, onKeyDown } = this.props;

        return (
            <div onKeyDown={onKeyDown}>
                {recentSearches.map(item => (
                    <div
                        key={item}
                        onClick={this.handleItemClick(item)}
                        onKeyDown={this.handleKeyDown(item)}
                        ref={this.getReference(item)}
                        tabIndex={0}
                        className="onsolve-menu-search__body__suggestion-item onsolve-recent-searches__list-item"
                        data-test="recent-search-item"
                    >
                        {item}
                        <IconButton
                            className="onsolve-recent-searches__list-item-action"
                            size="xs"
                            onClick={() => removeItem(item)}
                            tabIndex={0}
                            onKeyDown={this.handleTab}
                            data-test="recent-search-icon-button"
                        >
                            <TrashIcon color="secondary" />
                        </IconButton>
                    </div>
                ))}
            </div>
        );
    }
}

RecentSearchesItems.propTypes = {
    currentIndex: PropTypes.number,
    focusCurrentTrash: PropTypes.bool,
    isSelected: PropTypes.bool,
    onItemClick: PropTypes.func,
    onKeyDown: PropTypes.func,
    recentSearches: PropTypes.array,
    removeItem: PropTypes.func,
    tabOnTrash: PropTypes.func
};

export default withKeyboardControl(RecentSearchesItems);
